var _style, _path, _defs, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.9 20.4",
    style: {
      enableBackground: "new 0 0 14.9 20.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D1D1D1;}\n\t.st1{clip-path:url(#SVGID_00000168831151427922119580000000014861078071755165_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "message_alarm",
    transform: "translate(-93.024 -6.563)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48621",
    className: "st0",
    d: "M103.8,6.6h-9.4C93.7,6.6,93,7.2,93,8c0,0,0,0,0,0v17.4c0,0.8,0.7,1.5,1.5,1.5l0,0h9.4 c0.8,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0v-4.9c-0.5,0.2-1.1,0.4-1.6,0.4v1.6h-9V9h9v0.8c0.6,0.1,1.1,0.2,1.6,0.4V8 C105.3,7.2,104.7,6.6,103.8,6.6C103.9,6.6,103.8,6.6,103.8,6.6L103.8,6.6z M99.2,23.7c0.5,0,1,0.4,1,1s-0.4,1-1,1c-0.5,0-1-0.4-1-1 c0,0,0,0,0,0C98.2,24.2,98.6,23.7,99.2,23.7C99.2,23.7,99.2,23.7,99.2,23.7z M101.2,8.2h-4.2c-0.1,0-0.2-0.2-0.2-0.4 s0.1-0.4,0.2-0.4h4.2c0.1,0,0.2,0.2,0.2,0.4S101.4,8.2,101.2,8.2L101.2,8.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    transform: "translate(99.166 10.43)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 8.8,
    height: 10
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013890987831947105120000007289811497840788102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5905",
    style: {
      clipPath: "url(#SVGID_00000013890987831947105120000007289811497840788102_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48622",
    className: "st0",
    d: "M4.4,0c0.7,0,1.3,0.6,1.3,1.3C7,1.8,7.8,3,7.8,4.4v1.9c0.6,0,1,0.6,1,1.2 c0,0.6-0.5,1-1.1,1H1.1C0.5,8.4,0,8,0,7.4c0-0.6,0.4-1,1-1.1V4.4C1,3,1.8,1.8,3.1,1.3C3.1,0.6,3.7,0,4.4,0z M3.6,1.9 C2.5,2.3,1.8,3.3,1.8,4.4v2c0,0.4-0.3,0.7-0.7,0.7c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2h6.6c0.1,0,0.2-0.1,0.2-0.2 S7.8,7.1,7.7,7.1c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-2c0-1.1-0.7-2.1-1.8-2.4L4.9,1.8V1.3c0-0.3-0.3-0.5-0.6-0.4 c-0.2,0-0.4,0.2-0.4,0.4v0.5L3.6,1.9z M2.8,8.4h0.8c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7H6C6,9.3,5.3,10,4.4,10 S2.8,9.3,2.8,8.4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAlarm);
export default __webpack_public_path__ + "static/media/message_alarm.083dec422ddb27478cb06079ad566ecf.svg";
export { ForwardRef as ReactComponent };